import React, { Component } from 'react';
import { domainUrl } from '../config/Config';
import { reactLoader, getTokenData, message } from '../helpers/Common';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import {getInbox} from '../actions/inboxAction';
 class ComponentComplete extends Component {
    constructor(props) {
        super(props);
        this.state = {
            lrCount: "",
            performanceScore: "",
            totalPerformanceTest: "",
            cumulativeScore: "",
            
        };
        this.props.getInbox();
    }
    getLrCompletedPage(data) {
        reactLoader("show", "Please wait...");
        fetch(domainUrl + "get-lr-completed-page", {
            method: "POST",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                'Authorization': 'Bearer ' + getTokenData()
            },
            body: JSON.stringify({
                user_id: data.learner_id,
                learning_room_id: data.learning_room_id
            })
        }).then((response) => response.json()).then((responseJson) => {
            reactLoader("hide");
            if (responseJson.status === 0) {
                message(responseJson.message, responseJson.errors, "error");
            } else {
                this.setState({
                    lrCount: responseJson.lrCount,
                    performanceScore: responseJson.performanceScore,
                    totalPerformanceTest: responseJson.totalPerformanceTest,
                    cumulativeScore: responseJson.cumulativeScore
                });
            }
        });
    }
    componentDidMount() {
        const { data } = this.props;
        this.getLrCompletedPage(data);
       
    }
    componentWillReceiveProps(nextProps) {
        const { data } = nextProps;
        this.getLrCompletedPage(data);
    }
    
    goBackToComponentList() {
        const { data } = this.props;
        this.props.switchback("component_list", data.learning_room_id, data.dlr_id);
    }
    render() {
        return (<div className="main-inner">
            <div className="border-box">
                <section id="semana-scroll-inner" className="scroll">
                    <section className="viewport">
                        <section className="overview">
                            <div className="inner-content">
                                <div className="thanks-txt">
                                    <form id="contract" action="" method="post">
                                        <div>
                                            <h2>Congratulations !<br /><span>You have successfully completed LR {this.state.lrCount}.</span></h2>
                                            {this.state.totalPerformanceTest != 0 && <span>Your performance scores in this LR are given below.<br /><br /><br /></span>}
                                            {
                                                this.state.totalPerformanceTest != 0 && <ul>
                                                    <li className="bluetxt libtm">Performance Score<br />
                                                        <a className="orangenolnk" nohref="" title={this.state.performanceScore}>{this.state.performanceScore}</a>
                                                        <img src={process.env.PUBLIC_URL + '/images/performance-icon.jpg'} alt="" title="" />
                                                    </li>
                                                </ul>
                                            }
                                            <div className="clear" />
                                        </div>
                                        {/*<div>
                                            {
                                                this.state.totalPerformanceTest === 0 &&
                                                <span>
                                                    <span className="red-txt">*</span> Not Applicable - No scores for this Learning Room.
                                                </span>
                                            }
                                        </div>*/}
                                        {this.state.totalPerformanceTest != 0 && <div>
                                            <div className="allover-score">Cumulative Performance Score : {this.state.cumulativeScore}</div>
                                        </div>
                                        }
                                        {(this.props.usableType == "webapp") ? <div className="thanks-btn">
                                            <input value="Next" title="Next" type="button" onClick={() => this.goBackToComponentList()} />
                                        </div> : ""}
                                    </form>
                                </div>
                            </div>
                        </section>
                    </section>
                </section>
            </div>
        </div>);
    }
 }
  
  function mapDispatchToProps(dispatch) {
  
    return  bindActionCreators({getInbox}, dispatch);
  
  }
  
  export default connect(null,mapDispatchToProps)(ComponentComplete);
  


// WEBPACK FOOTER //
// ./src/lr_dlr_components/Thanks.js